import React from "react"
import {
  CycleChemicalMultiMeasurementListScreen,
  CycleCycleDiseaseListScreen,
  CycleFeedingTrayControlListScreen,
  CycleFeedListScreen,
  CycleHarvestListScreen,
  CycleMicrobiologyMultiMeasurementListScreen,
  CycleMortalityListScreen,
  CyclePlanktonMultiMeasurementListScreen,
  CycleSamplingListScreen,
  CycleTreatmentListScreen,
  CycleWaterQualityMultiMeasurementListScreen,
} from "../../../screens/home/cycle"
import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs"
import { OfflineModeIndicator, Text } from "../../../components"
import { translate } from "../../../i18n"
import { color, nativeBaseTheme } from "../../../theme"
import { Appearance, SafeAreaView, ViewStyle } from "react-native"
import _ from "lodash"

const TAB: ViewStyle = {
  width: 'auto',
  paddingHorizontal: 32,
  paddingVertical: 8
}

const TAB_FEED_RELATED: ViewStyle = {
  paddingHorizontal: 32,
  paddingVertical: 8
}

export type HomeCycleNavigatorParamList = {
  'Home.Cycle.WaterQualityMultiMeasurement.List': undefined,
  'Home.Cycle.Feed.List': undefined,
  'Home.Cycle.FeedingTrayControl.List': undefined,
  'Home.Cycle.Sampling.List': undefined,
  'Home.Cycle.Treatment.List': undefined,
  'Home.Cycle.Harvest.List': undefined,
  'Home.Cycle.Mortality.List': undefined,
  'Home.Cycle.ChemicalMultiMeasurement.List': undefined,
  'Home.Cycle.PlanktonMultiMeasurement.List': undefined,
  'Home.Cycle.MicrobiologyMultiMeasurement.List': undefined,
  'Home.Cycle.CycleDisease.List': undefined,
}

const Tab = createMaterialTopTabNavigator<HomeCycleNavigatorParamList>()

// export const CycleStack = {
//   index: 0,
//   routes: [
//     { name: 'Cycle.Stack', state: { index: 0, routes: [{ name: 'Cycle.WaterQualityMultiMeasurement.List' }] } }
//   ]
// };

export const CycleNavigator = () => {
  const colorScheme = "light" || Appearance.getColorScheme()

  return (<>
    <OfflineModeIndicator />
    <Tab.Navigator
      screenOptions={{
        tabBarActiveTintColor: colorScheme === 'light' ? color.primary : undefined,
        tabBarScrollEnabled: true,
        tabBarItemStyle: TAB,
        lazy: true,
        lazyPreloadDistance: 1
      }}
    >
      <Tab.Screen
        name="Home.Cycle.WaterQualityMultiMeasurement.List"
        component={CycleWaterQualityMultiMeasurementListScreen}
        options={{
          title: translate('multiMeasurements.waterQuality'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="multiMeasurements.waterQuality"
              transformText={_.startCase}
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
      <Tab.Screen
        name="Home.Cycle.Feed.List"
        component={CycleFeedListScreen}
        options={{
          title: translate('feeds.singular'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="feeds.singular"
              transformText={_.startCase}
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
      <Tab.Screen
        name="Home.Cycle.FeedingTrayControl.List"
        component={CycleFeedingTrayControlListScreen}
        options={{
          title: translate('feedingTrayControls.singular'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="feedingTrayControls.singular"
              transformText={_.startCase}
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
      <Tab.Screen
        name="Home.Cycle.Sampling.List"
        component={CycleSamplingListScreen}
        options={{
          title: translate('samplings.singular'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="samplings.singular"
              transformText={_.startCase}
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
      <Tab.Screen
        name="Home.Cycle.Treatment.List"
        component={CycleTreatmentListScreen}
        options={{
          title: translate('treatments.singular'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="treatments.singular"
              transformText={_.startCase}
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
      <Tab.Screen
        name="Home.Cycle.Harvest.List"
        component={CycleHarvestListScreen}
        options={{
          title: translate('harvests.singular'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="harvests.singular"
              transformText={_.startCase}
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
      <Tab.Screen
        name="Home.Cycle.Mortality.List"
        component={CycleMortalityListScreen}
        options={{
          title: translate('mortalities.singular'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="mortalities.singular"
              transformText={_.startCase}
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
      <Tab.Screen
        name="Home.Cycle.ChemicalMultiMeasurement.List"
        component={CycleChemicalMultiMeasurementListScreen}
        options={{
          title: translate('multiMeasurements.chemical'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="multiMeasurements.chemical"
              transformText={_.startCase}
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
      <Tab.Screen
        name="Home.Cycle.PlanktonMultiMeasurement.List"
        component={CyclePlanktonMultiMeasurementListScreen}
        options={{
          title: translate('multiMeasurements.plankton'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="multiMeasurements.plankton"
              transformText={_.startCase}
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
      <Tab.Screen
        name="Home.Cycle.MicrobiologyMultiMeasurement.List"
        component={CycleMicrobiologyMultiMeasurementListScreen}
        options={{
          title: translate('multiMeasurements.microbiology'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="multiMeasurements.microbiology"
              transformText={_.startCase}
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
      <Tab.Screen
        name="Home.Cycle.CycleDisease.List"
        component={CycleCycleDiseaseListScreen}
        options={{
          title: translate('cycleDiseases.singular'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="cycleDiseases.singular"
              transformText={_.startCase}
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
    </Tab.Navigator>
  </>
  )
}

export const CycleFeedRelatedNavigator = () => {
  const colorScheme = "light" || Appearance.getColorScheme()

  return (<>
    <OfflineModeIndicator />
    <Tab.Navigator
      screenOptions={{
        tabBarActiveTintColor: colorScheme === 'light' ? color.primary : undefined,
        tabBarItemStyle: TAB_FEED_RELATED,
        lazy: true,
        lazyPreloadDistance: 1
      }}
    >
      <Tab.Screen
        name="Home.Cycle.Feed.List"
        component={CycleFeedListScreen}
        options={{
          title: translate('feeds.singular'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="feeds.singular"
              transformText={_.startCase}
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
      <Tab.Screen
        name="Home.Cycle.FeedingTrayControl.List"
        component={CycleFeedingTrayControlListScreen}
        options={{
          title: translate('feedingTrayControls.singular'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="feedingTrayControls.singular"
              transformText={_.startCase}
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
    </Tab.Navigator>
  </>)
}
